import type Rollbar from 'rollbar';
import { RollbarConfig } from './types';

// Constants
const ACCESS_TOKEN = process.env.ROLLBAR_TOKEN || 'missing_token';
const ENV = process.env.ENV || 'development';

// Internal state
let realRollbar: Rollbar | null = null;
const queuedCalls: Array<[keyof Rollbar, unknown[]]> = [];

function init(): void {
  if (realRollbar || !window.rollbar) return;

  const config: RollbarConfig = {
    accessToken: ACCESS_TOKEN,
    captureUncaught: false,
    captureUnhandledRejections: false,
    payload: { environment: ENV, context: 'web-tools' }
  };
  realRollbar = new window.rollbar(config);

  // Replay buffered calls
  for (const [method, args] of queuedCalls) {
    (realRollbar as any)[method](...args);
  }
  queuedCalls.length = 0;
}

const handler: ProxyHandler<Rollbar> = {
  get(_, method: keyof Rollbar) {
    return (...args: unknown[]) => {
      if (realRollbar && typeof (realRollbar as any)[method] === 'function') {
        (realRollbar as any)[method](...args);
      } else {
        queuedCalls.push([method, args]);
      }
    };
  }
};

window.addEventListener('DOMContentLoaded', init);

export const rollbar = new Proxy<Rollbar>({} as Rollbar, handler);
